import React, { ReactElement, useState, ChangeEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  PopUp,
  EditCard,
  StyledIcon,
  StyledInputs,
  StyledInput,
} from '../../styled-components'

import { addCategory, updateCategory } from '../../../../api/category'
import { Category } from '../../../../types/training'
import Icon from '../../../icon'
import { Alert } from '../../../../constants/sweet-alert'
import Inputfield from '../../../input/input-field'
import Button from '../../../button'

interface CategoryAddEditProps {
  category: Category | Omit<Category, 'parts' | 'status'>
  onClose: () => void
  trainingId?: string
}

const CategoryAddEdit = ({
  category,
  onClose,
  trainingId,
}: CategoryAddEditProps): ReactElement => {
  const [title, setTitle] = useState(category?.title)
  const [placement, setPlacement] = useState(category?.placement)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const onEditSave = () => {
    const payload = {
      title,
      placement,
    }
    setLoading(true)
    updateCategory(category.id, payload).then((status) => {
      if (status === 200) {
        setLoading(false)

        Alert.fire({
          icon: 'success',
          title: `Updated`,
        })
        navigate(0)
      } else {
        setLoading(false)

        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
    })
  }

  const onAddSave = () => {
    if (trainingId) {
      setLoading(true)
      const payload = {
        category: {
          title,
          placement,
        },
        trainingId,
      }
      addCategory(payload).then((status) => {
        if (status === 201) {
          setLoading(false)
          Alert.fire({
            icon: 'success',
            title: `Created`,
          })
          navigate(0)
        } else {
          setLoading(false)
          Alert.fire({
            icon: 'error',
            title: `Error`,
          })
        }
      })
    }
  }

  return (
    <PopUp>
      <EditCard>
        <StyledIcon onClick={onClose}>
          <Icon name={'cil:x'} color="darkRed" width={20} height={20} />
        </StyledIcon>

        <StyledInputs>
          <StyledInput>
            <Inputfield
              value={title}
              labelName="العنوان"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setTitle(event.target.value)
              }
              type="text"
            />
            <Inputfield
              value={placement}
              labelName="الرتبة"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setPlacement(parseInt(event.target.value, 10))
              }
              type="number"
            />
          </StyledInput>
        </StyledInputs>

        <Button
          loading={loading}
          onClick={category.id ? onEditSave : onAddSave}
          color="red"
        >
          <Icon name="entypo:check" />
        </Button>
      </EditCard>
    </PopUp>
  )
}

export default CategoryAddEdit
